export const siteInfo = {
  name: '萝幼社',
  fullName: '萝幼社 - 官方正版授权平台',
  description: '萝幼社是专注于二次元文化的正版授权内容平台，汇聚海量优质创作资源，为广大二次元爱好者提供丰富的视觉内容与社区互动体验。',
  url: 'https://luoyoushe.com',
  logo: '萝幼社',
  founded: '2019',
  email: 'contact@luoyoushe.com',
  phone: '400-888-6666',
  address: '上海市浦东新区张江高科技园区动漫产业园 A 座 12 层',
  social: {
    weibo: 'https://weibo.com/luoyoushe',
    bilibili: 'https://space.bilibili.com/luoyoushe',
    wechat: 'luoyoushe_official',
  },
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '分类浏览', href: '/category/illustration' },
  { label: '关于我们', href: '/about' },
];

export const footerLinks = {
  explore: [
    { label: '插画作品', href: '/category/illustration' },
    { label: '漫画连载', href: '/category/comic' },
    { label: '同人创作', href: '/category/doujin' },
    { label: 'Cosplay', href: '/category/cosplay' },
    { label: '声优配音', href: '/category/voice' },
    { label: '动画短片', href: '/category/animation' },
  ],
  about: [
    { label: '品牌介绍', href: '/about' },
    { label: '用户口碑', href: '/about#reputation' },
    { label: '联系我们', href: '/about#contact' },
    { label: '加入我们', href: '/about#join' },
  ],
  legal: [
    { label: '用户协议', href: '/about' },
    { label: '隐私政策', href: '/about' },
    { label: '版权声明', href: '/about' },
  ],
};